export function deriveAppUrl(hostname: string = window.location.hostname): string {
  if (hostname.endsWith('.local.dabblewriter.com') || hostname === 'localhost') return 'https://local.dabblewriter.com';
  if (hostname.endsWith('.test.dabblewriter.com')) return 'https://test.dabblewriter.com';
  return 'https://app.dabblewriter.com';
}
